import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalTable,
  InputSearch,
  NormalSelect,
  NormalInput,
  NormalButton,
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  getStocks,
  ItemDivs,
  ItemClasses,
  ItemDepts,
  ItemBrands,
  ItemRanges,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactPaginate from "react-paginate";
import {
  getCommonApi,
  commonCreateApi,
  commonPatchApi,
  commonUpdateApi,
  commonDeleteApi,
} from "redux/actions/common";
import { BsFillHandIndexThumbFill } from "react-icons/bs";
import { FaPencilAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Back from "assets/images/back.png";
export class AddDisplayItemsClass extends Component {
  state = {
    SiteDetails: [
      {
        label: "Item Code",
      },
      {
        label: "Item Name",
      },
      {
        label: "Action",
      },
    ],
    headerDetails: [
      {
        label: "Stock Code",
        sortKey: "StockCode",
        enabled: true,
        id: "itemCode",
        singleClickFunc: () => this.handleSort("itemCode"),
        divClass: "justify-content-end",
      },
      {
        label: "Stock Name",
        sortKey: "Stock Name",
        enabled: true,
        id: "itemName",
        singleClickFunc: () => this.handleSort("itemName"),
      },
      {
        label: "Division",
        sortKey: "Division",
        enabled: true,
        id: "itemDiv",
        singleClickFunc: () => this.handleSort("itemDiv"),
      },
      {
        label: "Dept",
        sortKey: "Dept",
        enabled: true,
        id: "itemDept",
        singleClickFunc: () => this.handleSort("itemDept"),
      },
      {
        label: "Brand",
        sortKey: "Brand",
        enabled: true,
        id: "itemBrand",
        singleClickFunc: () => this.handleSort("itemBrand"),
      },
      {
        label: "Range",
        sortKey: "Range",
        enabled: true,
        id: "itemRange",
        singleClickFunc: () => this.handleSort("itemRange"),
      },
      {
        label: "Price",
        sortKey: "Price",
        enabled: true,
        id: "itemRange",
        singleClickFunc: () => this.handleSort("itemRange"),
      },
      {
        label: "",
      },
    ],
    staffList: [],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    orderBy: "desc",
    search: "",
    filterdata: [],
    offset: 0,
    data: [],
    perPage: 10,
    current_page: 1,
    Itemdata: [],
    searchData: [],
    tempdiv: "",
    pageMeta: {},
    display_items: [],
    itemCode: "",
    itemName: "",
    filteredData: {},
  };

  componentDidMount = () => {
    this.Listofstocks({});
    this.ListOfDisplayItems();
    console.log(this.props.location?.state?.data, "stateProps");
  };
  Listofstocks = async () => {
    this.updateState({ is_loading: true });
    await this.props.getStocks().then(async (res) => {
      console.log(res);
      let {
        staffList,
        pageCount,
        Itemdata,
        pageMeta,
        perPage,
        count,
        current_page,
      } = this.state;
      staffList = res;
      Itemdata = staffList.slice(
        (current_page - 1) * perPage,
        (current_page - 1) * perPage + perPage
      );

      console.log(Itemdata, "itemdata");
      pageCount = Math.ceil(staffList.length / this.state.perPage);
      console.log(staffList);
      console.log(pageCount, "PageCount");

      this.setState({
        staffList,
        pageCount,
        Itemdata,
        is_loading: false,
        isAll: true,
        isActive: false,
        isInactive: false,
        pageMeta: {
          ...pageMeta,
          total_pages: pageCount,
          per_page: Number(count),
        },
      });
      await this.props.ItemDivs().then((divResponse) => {
        let { staffList } = this.state;
        staffList.forEach((item) => {
          const matchingDiv = divResponse.find(
            (list) => Number(list.itmCode) === Number(item.itemDiv)
          );
          if (matchingDiv) {
            item.itemDiv = matchingDiv.itmDesc;
          }
        });
        this.setState({
          staffList,
        });
      });
      console.log(staffList, "staffListt");
      await this.props.ItemClasses().then((classResponse) => {
        let { staffList } = this.state;
        console.log(classResponse, "classRes");
        staffList.forEach((item) => {
          const matchingDiv = classResponse.find(
            (list) => Number(list.itmCode) === Number(item.itemClass)
          );
          if (matchingDiv) {
            item.itemClass = matchingDiv.itmDesc;
          }
        });
        this.setState({
          staffList,
        });
      });
      await this.props.ItemDepts().then((deptResponse) => {
        let { staffList } = this.state;

        staffList.forEach((item) => {
          const matchingDiv = deptResponse.find(
            (list) => Number(list.itmCode) === Number(item.itemDept)
          );
          if (matchingDiv) {
            item.itemDept = matchingDiv.itmDesc;
          }
        });
        this.setState({
          staffList,
        });
      });
      await this.props.ItemBrands().then((brandResponse) => {
        let { staffList } = this.state;

        staffList.forEach((item) => {
          const matchingDiv = brandResponse.find(
            (list) => Number(list.itmCode) === Number(item.itemBrand)
          );
          if (matchingDiv) {
            item.itemBrand = matchingDiv.itmDesc;
          }
        });
        this.setState({
          staffList,
        });
      });
      await this.props.ItemRanges().then((rangeRes) => {
        let { staffList } = this.state;

        staffList.forEach((item) => {
          const matchingDiv = rangeRes.find(
            (list) => Number(list.itmCode) === Number(item.itemRange)
          );
          if (matchingDiv) {
            item.itemRange = matchingDiv.itmDesc;
          }
        });
        this.setState({
          staffList,
        });
      });
      console.log(pageMeta, "PageMeta");
    });
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  ListOfDisplayItems = async () => {
    let { display_items } = this.state;

    await this.props
      .getCommonApi(`displayItems/?menucode=${this.props.location?.state?.id}`)
      .then((list) => {
        display_items = list.data.dataList;
      });
    console.log(display_items, "displayItems");
    this.setState({ display_items });
  };
  deleteDisplayItems = async (id) => {
    await this.props.commonDeleteApi(`displayItems/${id}/`).then(() => {
      this.ListOfDisplayItems();
    });
  };
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta, current_page, pageCount, staffList } =
      this.state;
    if (name == "count") {
      count = value;
      perPage = value;
      pageCount = Math.ceil(staffList.length / perPage);
      if (current_page > pageCount) {
        current_page = 1;
      }
      this.setState(
        {
          count,
          perPage,
          current_page,
          pageMeta: { ...pageMeta, per_page: +perPage, current_page },
        },
        () => {
          this.Listofstocks();
        }
      );
      console.log(count, perPage, "CountPerPage");
    }
  };
  handleChange = ({ target: { value, name } }) => {
    console.log(value, name);
    let { itemCode, itemName } = this.state;
    if (name == "itemCode") {
      itemCode = +value;
      this.setState({ itemCode });
    }
    if (name == "itemName") {
      itemName = +value;
      this.setState({ itemName });
    }
  };
  handlePageClick = (e) => {
    const selectedPage = e.page;

    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        current_page: selectedPage,
        pageMeta: { ...this.state.pageMeta, current_page: +selectedPage },
        offset: offset,
      },
      () => {
        this.Listofstocks();
      }
    );
  };

  Activeitem = async () => {
    this.updateState({ is_loading: true });
    await this.props.getStocks().then((res) => {
      let { pageCount, Itemdata } = this.state;
      let List = [];
      for (let key of res) {
        if (key.itemIsactive == true) {
          List.push({
            itemCode: key.itemCode,
            itemName: key.itemName,
            itmCode: key.itmCode,
            itemType: key.itemType,
            itemDiv: key.itemDiv,
            itemDept: key.itemDept,
            itemClass: key.itemClass,
            itemIsactive: key.itemIsactive,
            itemBrand: key.itemBrand,
            itemRange: key.itemRange,
          });
          console.log(List);
        }
      }
      Itemdata = List.slice(
        this.state.offset,
        this.state.offset + this.state.perPage
      );
      pageCount = Math.ceil(List.length / this.state.perPage);
      this.setState({
        pageCount,
        Itemdata,
        is_loading: false,
      });
    });
  };

  Inactiveitem = async () => {
    this.updateState({ is_loading: true });
    await this.props.getStocks().then((res) => {
      let { pageCount, Itemdata } = this.state;
      let List = [];
      for (let key of res) {
        if (key.itemIsactive == false) {
          List.push({
            itemCode: key.itemCode,
            itemName: key.itemName,
            itmCode: key.itmCode,
            itemType: key.itemType,
            itemDiv: key.itemDiv,
            itemDept: key.itemDept,
            itemClass: key.itemClass,
            itemIsactive: key.itemIsactive,
            itemBrand: key.itemBrand,
            itemRange: key.itemRange,
          });
          console.log(List);
        }
      }
      Itemdata = List.slice(
        this.state.offset,
        this.state.offset + this.state.perPage
      );
      pageCount = Math.ceil(List.length / this.state.perPage);
      this.setState({
        pageCount,
        Itemdata,
        is_loading: false,
      });
    });
  };

  filterByName = ({ target: { value, name } }) => {
    let {
      staffList,
      filterdata,
      search,
      searchData,
      pageCount,
      current_page,
      perPage,
      pageMeta,
      activeButton,
      inactiveButton,
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofstocks();
    }
    if (search !== "") {
      filterdata = staffList.filter((item) => {
        const isActive = item.itemIsactive ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseCode = item.itmCode.toLowerCase();
        const lowerCaseName = item.itemName.toLowerCase();
        const lowerCasecode = item.itmCode.toLowerCase();
        const lowerCaseType = item.itemType.toLowerCase();
        const lowerCaseDiv = item.itemDiv.toLowerCase();
        const lowerCaseDept = item.itemDept.toLowerCase();
        const lowerCaseClass = item.itemClass.toLowerCase();
        const lowerCaseBrand = item.itemBrand.toLowerCase();
        const lowerCaseRange = item.itemRange.toLowerCase();
        const lowerCaseActive = isActive.toLowerCase();
        if (activeButton && item.itemIsactive === false) {
          return false;
        }
        if (inactiveButton && item.itemIsactive === true) {
          return false;
        }
        return (
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseName.includes(lowerCaseSearch) ||
          lowerCasecode.includes(lowerCaseSearch) ||
          lowerCaseType.includes(lowerCaseSearch) ||
          lowerCaseDiv.includes(lowerCaseSearch) ||
          lowerCaseDept.includes(lowerCaseSearch) ||
          lowerCaseClass.includes(lowerCaseSearch) ||
          lowerCaseBrand.includes(lowerCaseSearch) ||
          lowerCaseRange.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = staffList;
    }

    this.setState({ filterdata }, () => {
      pageCount = Math.ceil(filterdata.length / this.state.perPage);

      if (current_page > pageCount) {
        current_page = 1;
      }
      this.setState({
        searchData: filterdata.slice(
          (current_page - 1) * perPage,
          (current_page - 1) * perPage + perPage
        ),
        pageCount,
        isActive: false,
        isAll: false,
        isInactive: false,
        pageMeta: { ...pageMeta, total_pages: pageCount, current_page },
      });
    });
  };

  handleSort = (sortkey, order) => {
    let { Itemdata, headerDetails, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    console.log("che");
    if (orderBy === "asc") {
      Itemdata.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      Itemdata.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      Itemdata,
    });
  };

  //   covertdiv = async(div) =>
  //   {

  //     let {tempdiv} = this.state;
  //     await this.props.ItemDivs().then(res => {

  //         for (let key of res) {
  //           if(key.itmCode == div)
  //           {
  //             tempdiv = key.itmDesc;
  //            this.setState({tempdiv})
  //           }
  //         }
  //     })
  // console.log(tempdiv)
  //     return false;
  //   }

  covertdiv = async (divss) => {
    await this.props.ItemDivs().then((res) => {
      debugger;
      let objIndex = res.filter((obj) => obj.itmCode == divss);
      if (objIndex) {
        return objIndex[0]["itmDesc"];
      } else {
        return "";
      }
    });
  };

  handleEdit = (stockCode) => {
    let { Itemdata, itemCode, itemName, filteredData } = this.state;

    filteredData = Itemdata.find((list) => list.itemCode === stockCode);
    itemCode = filteredData.itemCode;
    itemName = filteredData.itemDesc;
    this.setState({
      itemCode,
      itemName,
      filteredData,
    });
    console.log(filteredData, "editData");
  };
  handleSearchEdit = (stockCode) => {
    let { searchData, itemCode, itemName, filteredData } = this.state;
    filteredData = searchData.find((list) => list.itemCode === stockCode);
    itemCode = filteredData.itemCode;
    itemName = filteredData.itemDesc;
    this.setState({
      itemCode,
      itemName,
      filteredData,
    });
    console.log(filteredData, "editData");
  };
  AddItems = async () => {
    let { filteredData } = this.state;
    let { itemNo } = filteredData;
    let data = {
      stockid: itemNo,
      menu_code: this.props.location?.state?.data?.menu_code,
    };
    console.log(data, "data");
    await this.props.commonCreateApi(`displayItems/`, data).then(() => {
      this.ListOfDisplayItems();
      this.setState({
        itemCode: "",
        itemName: "",
      });
    });
  };
  render() {
    let {
      headerDetails,
      is_loading,
      option,
      count,
      search,
      searchData,
      display_items,
      SiteDetails,
      pageMeta,
      itemCode,
      itemName,
    } = this.state;
    console.log(pageMeta, "page_metaj");
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid itemmaster-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Display Catalog Items ")}
                  </h4>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-md-flex justify-content-between">
                  <p className="label-title text-center text-md-left text-lg-left mt-2 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    {this.props.location?.state?.data?.menu_description}
                  </p>
                  <p className="col-sm-12 col-md-4 col-lg-3 col-xl-3 mt-2">
                    <NormalButton
                      backend={true}
                      label={"Catalog Menu"}
                      onClick={() => this.props.history.goBack()}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-center justify-content-md-between col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                  <div className="p-1 d-flex   ">
                    <p className="mt-2 mr-1">{t("Show")}</p>
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                    <p className="mt-2 ml-1">{t("Entries")}</p>
                  </div>
                  <div className="p-1 ">
                    <InputSearch
                      onChange={this.filterByName}
                      placeholder="Search Stock Name"
                      type="search"
                    />
                  </div>
                </div>
              </div>
              {search.length > 1 ? (
                <div className="tab-table-content">
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={headerDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : searchData.length > 0 ? (
                          searchData.map(
                            (
                              {
                                itemCode,
                                itemName,
                                itmCode,
                                itemType,
                                itemDiv,
                                itemDept,
                                itemClass,
                                itemIsactive,
                                itemBrand,
                                itemRange,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td className="position-relative cursor-pointer">
                                    <div
                                      className="text-left cursor-pointer text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/itemCode/${itemCode}`
                                        )
                                      }
                                    >
                                      {itemCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemName}</div>
                                  </td>

                                  <td>
                                    <div className="text-left">{itemDiv}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemDept}</div>
                                  </td>

                                  <td>
                                    <div className="text-left">{itemBrand}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemRange}</div>
                                  </td>
                                  <td>
                                    <div></div>
                                  </td>
                                  <td>
                                    <div>
                                      <BsFillHandIndexThumbFill
                                        onClick={() =>
                                          this.handleSearchEdit(itemCode)
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="tab-table-content">
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={headerDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.Itemdata.length > 0 ? (
                          this.state.Itemdata.map(
                            (
                              {
                                itemCode,
                                itemName,
                                itmCode,
                                itemType,
                                itemDiv,
                                itemDept,
                                itemClass,
                                itemIsactive,
                                itemBrand,
                                itemRange,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td className="position-relative status-type">
                                    <div className="text-left ">{itemCode}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemName}</div>
                                  </td>

                                  <td>
                                    <div className="text-left">{itemDiv}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemDept}</div>
                                  </td>

                                  <td>
                                    <div className="text-left">{itemBrand}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itemRange}</div>
                                  </td>
                                  <td>
                                    <div>Price</div>
                                  </td>
                                  <td>
                                    <div>
                                      <BsFillHandIndexThumbFill
                                        onClick={() =>
                                          this.handleEdit(itemCode)
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-md-flex justify-content-start align-items-center">
              <div className="mx-md-3 col-md-4 col-sm-12 col-lg-4 col-xl-4">
                <label>Item Code</label>
                <NormalInput
                  type={"text"}
                  onChange={this.handleChange}
                  name="itemCode"
                  value={itemCode}
                  disabled={true}
                />
              </div>
              <div className="mx-md-3 col-md-4 col-sm-12 col-lg-4 col-xl-4">
                <label>Name</label>
                <NormalInput
                  type={"text"}
                  onChange={this.handleChange}
                  name="itemName"
                  value={itemName}
                  disabled={true}
                />
              </div>
              <div className="col-md-2 col-sm-12 col-lg-2 col-xl-2 mx-md-3 mt-4">
                <NormalButton
                  backend={true}
                  label="Add"
                  onClick={this.AddItems}
                />
              </div>
            </div>
            <div className="tab-table-content  col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <div className="d-md-flex">
                <h5 className="mt-3 ml-4 label-title col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-center text-md-left text-lg-left p-0">
                  {t("List of Items ")}
                </h5>
              </div>
              <div className="py-4">
                <div className="table-container">
                  <NormalTable headerDetails={SiteDetails}>
                    {is_loading ? (
                      <tr>
                        <td colSpan="7">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : display_items.length > 0 ? (
                      display_items.map(
                        ({ item_code, item_name, displayitem_id }, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="text-left ">{item_code}</div>
                              </td>
                              <td>
                                <div className="text-left">{item_name}</div>
                              </td>
                              <td>
                                <div>
                                  <h5>
                                    <MdDelete
                                      className="text-danger "
                                      onClick={() =>
                                        this.deleteDisplayItems(displayitem_id)
                                      }
                                    />
                                  </h5>
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )
                    ) : null}
                  </NormalTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getStocks,
      ItemDivs,
      getCommonApi,
      commonDeleteApi,
      commonCreateApi,
      ItemClasses,
      ItemDepts,
      ItemBrands,
      ItemRanges,
    },
    dispatch
  );
};

export const AddDisplayItems = withTranslation()(
  connect(null, mapDispatchToProps)(AddDisplayItemsClass)
);
